import { render, staticRenderFns } from "./seller.vue?vue&type=template&id=56b8207e&scoped=true"
import script from "./seller.vue?vue&type=script&lang=js"
export * from "./seller.vue?vue&type=script&lang=js"
import style0 from "./seller.vue?vue&type=style&index=0&id=56b8207e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8207e",
  null
  
)

export default component.exports